/*
 * BACHGOLD PDP — FILTER-TECHNOLOGIE Tab-Switcher
 * ----------------------------------------------
 * Desktop:
 *   - Auto-Advance (6s / Tab) via CSS-animationend
 *   - Click + Keyboard (Arrow/Home/End)
 *   - Pause/Play-Button
 *   - IntersectionObserver pausiert out-of-view
 * Mobile (<900px):
 *   - Horizontales Scroll-Snap-Karussell (CSS)
 *   - Dot-Pagination synct via IntersectionObserver auf Cards
 *   - Click auf Dot → smooth-scroll zur Card
 *   - Image-Swap folgt dem scroll-aktiven Tab
 */
(function () {
  'use strict';

  var MOBILE_BREAKPOINT = 900;

  function init() {
    var sections = document.querySelectorAll('[data-ftech]');
    if (!sections.length) return;
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    sections.forEach(function (section) {
      var tabs = Array.from(section.querySelectorAll('[data-ftech-tab]'));
      var images = section.querySelectorAll('[data-ftech-image]');
      var playpause = section.querySelector('[data-ftech-playpause]');
      var tabsList = section.querySelector('.bb-ftech__tabs');
      var dots = Array.from(section.querySelectorAll('[data-ftech-dot]'));
      if (!tabs.length) return;

      function isMobile() {
        return window.innerWidth < MOBILE_BREAKPOINT;
      }

      function activate(idx) {
        tabs.forEach(function (t) {
          var on = t.getAttribute('data-ftech-tab') === idx;
          if (on && !isMobile()) {
            // Desktop: Reflow-Trick um CSS-Animation neu zu starten
            var fill = t.querySelector('.bb-ftech__progress-fill');
            if (fill) {
              t.classList.remove('is-active');
              void fill.offsetWidth;
            }
          }
          t.classList.toggle('is-active', on);
          var trigger = t.querySelector('.bb-ftech__tab-trigger');
          if (trigger) trigger.setAttribute('aria-selected', on ? 'true' : 'false');
        });
        images.forEach(function (img) {
          img.classList.toggle('is-active', img.getAttribute('data-ftech-image') === idx);
        });
        dots.forEach(function (dot) {
          dot.classList.toggle('is-active', dot.getAttribute('data-ftech-dot') === idx);
        });
      }

      function nextTab() {
        var active = section.querySelector('.bb-ftech__tab.is-active');
        if (!active) return;
        var i = tabs.indexOf(active);
        var ni = (i + 1) % tabs.length;
        activate(tabs[ni].getAttribute('data-ftech-tab'));
      }

      // ============ DESKTOP: animationend → nextTab ============
      tabs.forEach(function (tab) {
        var fill = tab.querySelector('.bb-ftech__progress-fill');
        if (fill) {
          fill.addEventListener('animationend', function () {
            if (
              !isMobile() &&
              tab.classList.contains('is-active') &&
              !section.classList.contains('bb-ftech--paused') &&
              !section.classList.contains('bb-ftech--paused-auto')
            ) {
              nextTab();
            }
          });
        }

        var trigger = tab.querySelector('.bb-ftech__tab-trigger');
        if (!trigger) return;

        trigger.addEventListener('click', function () {
          activate(tab.getAttribute('data-ftech-tab'));
          if (isMobile() && tabsList) {
            // Auf Mobile: zusätzlich zur Card scrollen
            tab.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
          }
        });

        trigger.addEventListener('keydown', function (e) {
          var i = tabs.indexOf(tab);
          var ni = null;
          if (e.key === 'ArrowDown' || e.key === 'ArrowRight') ni = (i + 1) % tabs.length;
          else if (e.key === 'ArrowUp' || e.key === 'ArrowLeft') ni = (i - 1 + tabs.length) % tabs.length;
          else if (e.key === 'Home') ni = 0;
          else if (e.key === 'End') ni = tabs.length - 1;
          if (ni === null) return;
          e.preventDefault();
          var nextTrigger = tabs[ni].querySelector('.bb-ftech__tab-trigger');
          if (nextTrigger) nextTrigger.focus();
          activate(tabs[ni].getAttribute('data-ftech-tab'));
        });
      });

      // ============ MOBILE: Scroll-Sync via IntersectionObserver ============
      if ('IntersectionObserver' in window && tabsList) {
        var scrollObs = new IntersectionObserver(function (entries) {
          if (!isMobile()) return;
          entries.forEach(function (entry) {
            if (entry.isIntersecting && entry.intersectionRatio > 0.6) {
              var idx = entry.target.getAttribute('data-ftech-tab');
              if (idx) activate(idx);
            }
          });
        }, {
          root: tabsList,
          threshold: [0.6]
        });
        tabs.forEach(function (t) { scrollObs.observe(t); });
      }

      // ============ MOBILE: Dot-Click → Smooth-Scroll ============
      dots.forEach(function (dot) {
        dot.addEventListener('click', function () {
          var idx = dot.getAttribute('data-ftech-dot');
          var targetTab = tabs.find(function (t) {
            return t.getAttribute('data-ftech-tab') === idx;
          });
          if (!targetTab) return;
          activate(idx);
          if (isMobile() && tabsList) {
            targetTab.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
          }
        });
      });

      // ============ Pause/Play-Button (Desktop Auto-Advance) ============
      if (playpause) {
        playpause.addEventListener('click', function () {
          var nowPaused = section.classList.toggle('bb-ftech--paused');
          playpause.setAttribute('aria-pressed', nowPaused ? 'true' : 'false');
          playpause.setAttribute(
            'aria-label',
            nowPaused ? 'Auto-Rotation fortsetzen' : 'Auto-Rotation pausieren'
          );
        });
      }

      // ============ IntersectionObserver Section: pause out-of-view ============
      if ('IntersectionObserver' in window && !reduceMotion) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            section.classList.toggle('bb-ftech--paused-auto', !entry.isIntersecting);
          });
        }, { threshold: 0.3 });
        io.observe(section);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
